module.exports = {"370405001":"运河街道","370405100":"邳庄镇","370405101":"张山子镇","370405102":"泥沟镇","370405103":"涧头集镇","370405104":"马兰屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370405.json
// module id = 1387
// module chunks = 0